import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import MailIcon from '@material-ui/icons/Mail'
import InboxIcon from '@material-ui/icons/MoveToInbox'

import * as React from 'react'
import { Link, RouteComponentProps, withRouter } from 'react-router-dom'
import DrawerService from '../../services/drawer'

import './style.scss'

interface IMenuItem {
  name: string
  icon?: any
  link: string
}

interface IBottomMenuItem {
  title: string
  content: string
  image: string
}

interface INativeProps {
  bottom?: boolean
  viewAnswers?: any
  distributeForm?: any
  sendReminder?: any
  formId?: string
}

export interface IProps extends RouteComponentProps, INativeProps {}
export interface IState {
  open: boolean
}
class TemporaryDrawer extends React.Component<IProps, IState> {
  state = {
    open: false
  }

  bottomItems: IBottomMenuItem[] = [
    {
      title: 'View Answers',
      content: 'Review form answers from parents and key people',
      image: require('../../assets/img/view.svg')
    },
    {
      title: 'Distribute form',
      content: 'Select which user you want to send the form to complete',
      image: require('../../assets/img/airplane.svg')
    },
    {
      title: 'Send reminder',
      content:
        'We can send a reminder to any key personel to complete a desired orm',
      image: require('../../assets/img/timer.svg')
    }
  ]

  items: IMenuItem[] = [
    {
      name: 'Patient List',
      icon: undefined,
      link: '/patients_list'
    },
    {
      name: 'Questionnaires',
      icon: undefined,
      link: '/questionnaires'
    },
    {
      name: 'Games',
      icon: undefined,
      link: '/games'
    },
    {
      name: 'Dashboards',
      icon: undefined,
      link: '/dashboards'
    }
  ]
  componentDidMount() {
    DrawerService.showDrawer = this.showDrawer
  }

  showDrawer = () => this.setState({ open: true })
  hideDrawer = () => this.setState({ open: false })

  toggleDrawer = () => this.setState(({ open }) => ({ open: !open }))
  render() {
    const BottomList = (
      <div style={{ width: '100%' }}>
        <List>
          {this.bottomItems.map((item, index) => (
            <React.Fragment key={index}>
              <ListItem
                button={true}
                className="bottom-list-item"
                onClick={() => {
                  index === 0
                    ? this.props.viewAnswers(this.props.formId)
                    : index === 1
                    ? this.props.distributeForm()
                    : this.props.sendReminder()
                }}
                style={{
                  paddingBottom: 30,
                  paddingTop: 30,
                  borderRadius: 5,
                  display: 'flex',
                  alignItems: 'flex-start'
                }}
              >
                <img className="item-image" src={item.image} />
                <div className="content-wrapper">
                  <div className="content-title">{item.title}</div>
                  <div className="content">{item.content}</div>
                </div>
              </ListItem>

              {index === 2 ? null : <Divider />}
            </React.Fragment>
          ))}
        </List>
      </div>
    )

    const sideList = (
      <div style={{ width: 250 }}>
        <List>
          {this.items.map((item, index) => (
            <Link to={item.link} key={index} style={{ textDecoration: 'none' }}>
              <ListItem button={true}>
                {item.icon ? item.icon : null}
                {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
                <ListItemText primary={item.name} />
              </ListItem>
            </Link>
          ))}
        </List>
        <Divider />
        <List>
          {['Logout'].map((text, index) => (
            <ListItem
              button={true}
              key={text}
              onClick={() => {
                window.location.href = window.location.origin
              }}
            >
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
      </div>
    )

    return (
      <div>
        <Drawer
          anchor={this.props.bottom ? 'bottom' : 'left'}
          open={this.state.open}
          onClose={this.hideDrawer}
          className={this.props.bottom ? 'bottom-menu' : ''}
        >
          <div className="menu-top" />

          <div
            style={{ borderRadius: 10 }}
            tabIndex={0}
            role="button"
            onClick={this.toggleDrawer}
            onKeyDown={this.toggleDrawer}
          >
            {!this.props.bottom ? sideList : BottomList}
          </div>
        </Drawer>
      </div>
    )
  }
}
export default withRouter(TemporaryDrawer)



// WEBPACK FOOTER //
// ./src/components/Drawer/index.tsx